<template>
    <div :class="className">
        <div
            class="c-accordion__header"
            @click="isOpen ? close() : open()"
        >
            <slot name="title">
                <h3
                    v-if="title"
                    class="c-accordion__title"
                >
                    {{ title }}
                </h3>
            </slot>
            <icon icon="arrow-down" class="c-accordion__icon"/>
        </div>
        <div
            ref="container"
            class="c-accordion__container"
        >
            <div ref="inner" class="c-accordion__content">
                <slot>
                    <div
                        class="t-cms"
                        v-html="content"
                    />
                </slot>
            </div>
        </div>
    </div>
</template>

<script>

import { gsap } from 'gsap/all';
import Icon from 'objects/Icon'

export default {
    name: 'Accordion',
    components: {
        Icon
    },
    data: () => ({
        isOpen: false,
    }),
    props: {
        title: {
            type: String,
            default: null,
        },
        content: {
            type: String,
            default: null,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        upsideDown: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        openDefault: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        className() {
            let classname = 'c-accordion'

            if(this.isOpen) {
                classname += ' is-open'
            }

            if(this.upsideDown) {
                classname += ` -upside-down`
            }

            return classname
        }
    },
    mounted() {

        if (this.openDefault)
            this.open()
    },
    methods: {
        open() {
            this.isOpen = true;

            const height = this.$refs.inner.offsetHeight;

            gsap.to(this.$refs.container, {
                duration: 1,
                height,
                opacity: 1,
                onComplete: () => {
                    gsap.set(this.$refs.container, {
                        height: 'auto'
                    });
                },
                ease: 'expo.out',
            });

            //const rect = this.$refs.container.getBoundingClientRect()
        },
        close() {
            this.isOpen = false;

            gsap.to(this.$refs.container, {
                duration: .6,
                height: 0,
                opacity: 0,
                onComplete: () => {
                    gsap.set(this.$refs.container, {
                        height: 0
                    });
                },
                ease: 'expo.out',
            });
        },
        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
    },
};
</script>

<style lang="scss">

.c-accordion {

    &.is-open {

        .c-accordion__content {
            pointer-events: initial;
        }

        .c-accordion__icon {
            transform: rotate(-180deg);
        }

    }

    &__icon {
        transition: transform 0.6s $out-expo;
    }

    &.-upside-down {
        display: flex;
        flex-direction: column;

        .c-accordion__header {
            order: 2
        }

        .c-accordion__container {
            order: 1
        }
    }
}


.c-accordion__header {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $color-beige;
    padding-bottom: 1.5rem;
}

.c-accordion__container {
    height: 0;
    opacity: 0;
    overflow: hidden;
}


.c-accordion__content {
    padding: 1em 0;
    pointer-events: none;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    @media #{md('md')} {
        columns: 2;
        column-gap: var(--grid-gutter);
    }
}

</style>
